import { RequestStatus } from '../../enums';
import { makeAsyncReducerHandlers } from '../../helpers';
import {
  PackagesActionTypes,
  ProjectsActionTypes,
  InterviewsActionTypes,
} from '../../actions/types';

const fetchPackageByProjectId = makeAsyncReducerHandlers(
  PackagesActionTypes.fetchPackageByProjectId,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.package],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const fetchPackageForProofByProjectId = makeAsyncReducerHandlers(
  PackagesActionTypes.fetchPackageForProofByProjectId,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.package],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);


const fetchPackageByCustomerId = makeAsyncReducerHandlers(
  PackagesActionTypes.fetchPackageByCustomerId,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.package],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const fetchDataToCreateProject = makeAsyncReducerHandlers(
  ProjectsActionTypes.fetchDataToCreateProject,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: action.payload.packages,
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const fetchDataToEditProject = makeAsyncReducerHandlers(
  ProjectsActionTypes.fetchDataToEditProject,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: action.payload.packages,
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const editProjectWithRelatedData = makeAsyncReducerHandlers(
  ProjectsActionTypes.editProjectWithRelatedData,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const { package: packageDoc } = action.payload;
    const items = Array.from(state.items);
    const index = items.findIndex(item => item.type === packageDoc.type);

    if (index === -1) {
      items.push(packageDoc);
    } else {
      items.splice(index, 1, packageDoc);
    }

    return {
      items,
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const fetchProjectOverviewDataByProjectId = makeAsyncReducerHandlers(
  ProjectsActionTypes.fetchProjectOverviewDataByProjectId,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.package],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const fetchProjectOverviewDataByCustomerId = makeAsyncReducerHandlers(
  ProjectsActionTypes.fetchProjectOverviewDataByCustomerId,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.package],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const fetchChaptersAndResourcesByProjectId = makeAsyncReducerHandlers(
  ProjectsActionTypes.fetchChaptersAndResourcesByProjectId,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.package],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const getBookSampleAndResourcesByProjectId = makeAsyncReducerHandlers(
  ProjectsActionTypes.getBookSampleAndResourcesByProjectId,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.package],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const fetchChaptersAndResourcesByUser = makeAsyncReducerHandlers(
  ProjectsActionTypes.fetchChaptersAndResourcesByUser,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.package],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const getBookSampleAndResourcesByUser = makeAsyncReducerHandlers(
  ProjectsActionTypes.getBookSampleAndResourcesByUser,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.package],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const getInterviewsInfo = makeAsyncReducerHandlers(
  InterviewsActionTypes.getInterviewsInfo,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.package],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const fetchTimelineDataByCustomer = makeAsyncReducerHandlers(
  ProjectsActionTypes.fetchTimelineDataByCustomer,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.package],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const getDataForUpgradesByProjectId = makeAsyncReducerHandlers(
  PackagesActionTypes.getDataForUpgradesByProjectId,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.package],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const completeUpgradeRequest = makeAsyncReducerHandlers(
  ProjectsActionTypes.completeUpgradeRequest,
  (state) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.package],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

export default {
  fetchProjectOverviewDataByProjectId,
  fetchProjectOverviewDataByCustomerId,
  fetchPackageByProjectId,
  fetchDataToCreateProject,
  fetchDataToEditProject,
  editProjectWithRelatedData,
  fetchPackageByCustomerId,
  fetchPackageForProofByProjectId,
  fetchChaptersAndResourcesByProjectId,
  getInterviewsInfo,
  fetchTimelineDataByCustomer,
  fetchChaptersAndResourcesByUser,
  getDataForUpgradesByProjectId,
  getBookSampleAndResourcesByUser,
  getBookSampleAndResourcesByProjectId,
  completeUpgradeRequest,
};
